import React from "react";
import { useMediaQuery } from "./useMediaQuery";

export function useMouseHover<T = Element>(): [
    boolean,
    { onPointerOver: React.PointerEventHandler<T>; onPointerOut: React.PointerEventHandler<T> },
] {
    const [hover, setHover] = React.useState(false);
    const canHover = useMediaQuery("(hover: hover)");

    const onPointerOver: React.PointerEventHandler<T> = React.useCallback(
        (e) => {
            if (canHover && e.pointerType === "mouse") {
                setHover(true);
            }
        },
        [canHover],
    );

    const onPointerOut: React.PointerEventHandler<T> = React.useCallback(
        (e) => {
            if (canHover && e.pointerType === "mouse") {
                setHover(false);
            }
        },
        [canHover],
    );

    const pointerHandlers = React.useMemo(
        () => ({
            onPointerOver,
            onPointerOut,
        }),
        [onPointerOver, onPointerOver],
    );

    return [hover, pointerHandlers];
}
